var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Box, Heading, Icon, Link } from '@chakra-ui/react';
import { Heart } from 'akar-icons';
var Footer = function (props) {
    return (_jsx(_Fragment, { children: _jsx(Box, __assign({ justifyContent: "center", alignItems: 'center', py: "5", mt: 3, pb: "10" }, { children: _jsxs(Heading, __assign({ as: "h3", display: 'flex', justifyContent: "center", alignItems: 'center', w: "100%" }, { children: ["Made with ", _jsx(Icon, { as: Heart, display: "inline", mx: 2, mt: 2, strokeWidth: "3" }), " by", ' ', _jsx(Link, __assign({ href: "https://github.com/cjlaserna/", mx: 2 }, { children: "cjlaserna" }))] })) })) }));
};
export default Footer;
